import axios from "axios";
import { cropr } from "../adapter";
import { jwtClient } from "./authUtils";

export const REQUEST_SENSORS = "REQUEST_SENSORS";
const requestSensors = () => {
  return {
    type: REQUEST_SENSORS,
  };
};

export const RECEIVE_SENSORS = "RECEIVE_SENSORS";
const receiveSensors = (sensors) => {
  return {
    type: RECEIVE_SENSORS,
    items: sensors,
  };
};

export const FAILED_SENSORS = "FAILED_SENSORS";
const failedSensors = () => {
  return {
    type: FAILED_SENSORS,
  };
};

export const fetchSensors = (apiUrl) => {
  return async (dispatch) => {
    dispatch(requestSensors());
    let sensorsCacheKey = "sensorsCache" + cropr.farm.id;
    let timestampCacheKey = "timestampCache" + cropr.farm.id;
    try {
      let responseText = window.localStorage.getItem(sensorsCacheKey);
      const timestampCache = window.localStorage.getItem(timestampCacheKey);

      if (timestampCache) {
        const now = new Date();
        if (now.getTime() > parseInt(timestampCache) + 30 * 60 * 1000) {
          responseText = null;
        }
      } else {
        responseText = null;
      }

      let sensors;
      if (responseText) {
        sensors = JSON.parse(responseText);
      } else {
        var url = apiUrl + "/api/product/installation/soil/?format=json";
        if (cropr.features.irrigation && cropr.features.irrigation !== 0) {
          url += "&irrigation=true";
        }
        if (cropr.l10n.languageCode) {
          url += "&lang=" + cropr.l10n.languageCode;
        }

        const response = await jwtClient.withJWT(async (jwt) => {
          return axios.get(url, {
            headers: { Authorization: "JWT " + jwt },
          });
        });

        const now = new Date();
        window.localStorage.setItem(timestampCacheKey, now.getTime().toString());
        window.localStorage.setItem(sensorsCacheKey, JSON.stringify(response.data));
        sensors = response.data;
      }
      return dispatch(receiveSensors(sensors));
    } catch (err) {
      window.localStorage.removeItem(timestampCacheKey);
      window.localStorage.removeItem(sensorsCacheKey);
      return dispatch(failedSensors());
    }
  };
};
